
import logo from "@/assets/univdiam.png"

import RightContainer from '@/components/auth/RightContainer'
import { Link, useSearchParams } from 'react-router-dom'
import { useMutation } from '@tanstack/react-query'
import api from '@/http/api'
import { toast } from 'sonner'
import { Toaster } from "@univdiam/ui/components/sonner"
import { LoaderCircle } from 'lucide-react'

const resendVerificationEmail = (email: string) => {
    return api.post('/customer/resend-verification-email', { email })
}

const Onboard = () => {
    const [searchParams] = useSearchParams();
    const customer = searchParams.get('name')
    const email = searchParams.get('email')
    const email_verification = searchParams.get('email_verification')
    const isVerified = searchParams.get('isVerified')

    const { mutate: resend, isPending: isResending } = useMutation({
        mutationFn: () => resendVerificationEmail(email!),
        onSuccess: ({ data }) => {
            if (data?.success) {
                toast.success('Verification email sent')
            } else {
                toast.error(data?.error || 'Could not resend verification email')
            }
        },
        onError: () => toast.error('Could not resend verification email')
    })

    return (
        <div className='grid grid-cols-1 lg:grid-cols-2 min-h-screen'>
            <div className="flex flex-col justify-between min-h-screen p-[20px] lg:p-[40px] items-center">

                <div className="flex-1 flex items-center justify-center">
                    <div className="w-full lg:w-[440px]">
                        <img src={logo} alt="Univ Daim" />
                        <p className="text-heading2 mt-[32px] lg:mt-[64px]">Welcome, {customer}</p>
                        {
                            email_verification ? <p className="text-heading6 text-secondary mt-[8px] mb-[32px]">
                                Your email is not verified yet! you can verify your email by clicking the link we sent to your inbox.
                            </p> : isVerified === 'true' ? <p className="text-heading6 text-secondary mt-[8px] mb-[32px]">
                                Your email has been verified. You're almost there! We're currently verifying your details. This should only take a few hours.
                            </p> : <p className="text-heading6 text-secondary mt-[8px] mb-[32px]">
                                You are almost done! We are verifying your details. Meanwhile, you can verify your email by clicking the link we sent to your inbox.
                            </p>
                        }
                        <div className="flex items-center justify-between">
                            <p className='text-body2 text-highlight mt-[16px]'><Link to={'/login'}>
                                <span className='text-[#16111] font-[700] cursor-pointer underline'>Log in</span> to your account
                            </Link></p>
                            {email && (
                                <p className='text-body2 text-highlight mt-[16px]'>
                                    <span
                                        className={`text-[#16111] font-[700] underline ${isResending ? 'opacity-50 pointer-events-none' : 'cursor-pointer'}`}
                                        onClick={() => !isResending && resend()}
                                    >
                                        {isResending ? <LoaderCircle className="inline size-4 animate-spin" /> : 'Resend'}
                                    </span> verification email
                                </p>
                            )}
                        </div>
                    </div>
                </div>

                <div className="flex flex-col lg:flex-row items-center justify-center gap-[8px] lg:gap-[32px]">
                    <p className='text-secondary text-caption2'>© 2026 Universal Diamonds. All rights reserved</p>
                    <p className='text-caption2 text-[#202020] font-[500]'><Link to={'/'}>Privacy Policy</Link> • <Link to={
                        '/'
                    }>Terms & Condition</Link></p>
                </div>
            </div>
            <RightContainer />
            <Toaster />
        </div>
    )
}

export default Onboard